module.exports = __webpack_public_path__ + "img/plusblue.6f4d5bbc.svg";